module.exports = __webpack_public_path__ + "static/media/button_ren3a3a487008ed5cf89bba53d833aec9be.webp";